import { render, staticRenderFns } from "./CmgStarStrip.vue?vue&type=template&id=14449d00&scoped=true&lang=pug"
import script from "./cmg-star-strip.ts?vue&type=script&lang=ts&external"
export * from "./cmg-star-strip.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgStarStrip.vue?vue&type=style&index=0&id=14449d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14449d00",
  null
  
)

export default component.exports